const initializeTracker = ({ id, name }) => {
  window.ga('create', id, 'auto', name);
  return name;
};

export default initializeTracker;
